import { Button, Icon } from '@chakra-ui/react'
import { Link } from 'gatsby'
import React from 'react'
import { FaHistory } from 'react-icons/fa'
import { UserRoutes } from '~config/routes'

export default function PendingActionHistoryButton() {
    return (
        <Link to={UserRoutes.PendingActionsHistory}>
            <Button
                size="xs"
                h="28px"
                rounded="full"
                variant="outline"
                bg="white"
                leftIcon={<Icon as={FaHistory} />}
            >
                View History
            </Button>
        </Link>
    )
}
